import { BaseModel } from "./BaseModel";
import IErrorData from "../server/data/errorData";

class ErrorModel extends BaseModel<IErrorData> {
    public errorCode: number = -1;
    public errorMessage: string = "";
    public displayMessage: string = "";
    public critical: boolean = false;
    public rawError: any;

    public cleanUp() {
        // if ( !this.critical ) {
            this.errorMessage = "";
            this.displayMessage = "";
            this.errorCode = -1;
            this.critical = false;
        // }
    }

    public hasError(): boolean {
        return this.errorCode >= 0;
    }

    public update(data?: any) {
        try {
            if(data.data) {
                this.errorCode = data.data.error == 0? -1 : data.data.error
            } else {
                this.errorCode = data.errorCode;
            }

            // Some errors provides additional detals

            const errorMessage = data?.errorDetails?.message || data?.errorMessage;
            if (errorMessage) {
                this.errorMessage = errorMessage;
            }

            const displayMessage = data?.errorDetails?.title;
            if (displayMessage) {
                this.displayMessage = displayMessage;
            }
            this.rawError = data;
        } catch (error) {
        }
    }
}


export default new ErrorModel();
